import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../core/services/api.service';
import { ConfigService } from '../core/services/config.service';
import { SettingDto, SettingResponse } from '../core/models/setting.model';

@Injectable({
  providedIn: 'root'
})

export class QuoteService {

  constructor(private apiService: ApiService, private configService: ConfigService) {
  }

  public save(quote: any): Observable<any> {
    const apiEndpoint = this.configService.QuoteApplicationUrl;
    return this.apiService.save<any>(apiEndpoint, quote);
  }

  public submit(quote: any): Observable<any> {
    const apiEndpoint = this.configService.QuoteSubmitUrl
    return this.apiService.save<any>(apiEndpoint, quote);
  }

  public get(id: number): Observable<any> {
    const apiEndpoint = this.configService.QuoteApplicationGetByIdUrl.replace("{id}", id.toString());
    return this.apiService.find<any>(apiEndpoint);
  }

  public getQuoteApplicationStatus(applicationId: number): Observable<any> {
    const url = this.configService.QuoteApplicationUrl + "/quoteapplicationstatus/{id}/".replace("{id}", applicationId.toString());
    return this.apiService.find(url, null);
  }

  public update(quote: any): Observable<any> {
    const apiEndpoint = this.configService.QuoteUpdateUrl.replace("{id}", quote.id.toString());
    return this.apiService.update(apiEndpoint, quote);
  }

  public delete(id: number): Observable<any> {
    const apiEndpoint = this.configService.QuoteDeleteUrl + "/{id}".replace("{id}", id.toString());
    return this.apiService.remove(apiEndpoint);
  }

  public getQuoteApplicationsByUser(keyword: string): Observable<any> {
    const url = this.configService.QuoteApplicationUrl + "/developerlist/" + keyword;
    return this.apiService.find(url, null);

  }

  public getQuotePaymentByUser(): Observable<any> {
    const url = this.configService.QuoteApplicationUrl + "/payments/";
    return this.apiService.find(url, null);

  }

  public addCredit(quote: any): Observable<any> {
    const apiEndpoint = this.configService.QuoteCreditAddUrl.replace("{id}", quote.quoteId.toString());
    return this.apiService.save<any>(apiEndpoint, quote);
  }

  public updateCredit(id: number, credit: any): Observable<any> {
    const apiEndpoint = this.configService.QuoteUpdateUrl.replace("{id}", id.toString());
    return this.apiService.update(apiEndpoint, credit);
  }

  public deleteQuoteCredit(id: number): Observable<any> {
    const apiEndpoint = this.configService.QuoteCreditDeleteUrl.replace("{id}", id.toString());
    return this.apiService.remove(apiEndpoint);
  }

  public getDocuments(applicationId: number): Observable<any> {
    const url = this.configService.QuoteApplicationUrl + "/{id}/documents".replace("{id}", applicationId.toString());
    return this.apiService.find(url, null);
  }

  public convertToApplication(request: any): Observable<any> {
    const apiEndpoint = this.configService.QuoteApplicationUrl + "/convertquote/";
    return this.apiService.save<any>(apiEndpoint, request);
  }

  
  public rtmp(request: any,id: number): Observable<any> {
    const apiEndpoint = this.configService.QuoteApplicationUrl +"/{id}/rtmp".replace('{id}', id.toString());
    return this.apiService.save<any>(apiEndpoint, request);
  }


  public getQuoteStatement(applicationId: number): Observable<any> {
    const url = this.configService.QuoteApplicationUrl + "/credit/{id}/statement".replace("{id}", applicationId.toString());
    return this.apiService.find(url, null);
  }

  public updateCWR(applicationId: number, commwealthReference: string): Observable<any> {
    const url = this.configService.QuoteApplicationUrl + "/updateCWR/" + applicationId + "/" + commwealthReference;
    return this.apiService.update(url, {});
  }

  public updateRTMPDevelopmentDetails(applicationId: number, request: any): Observable<any> {
    const url = this.configService.QuoteApplicationUrl + "/rtmp/developmentdetails/" + applicationId;
    return this.apiService.update(url, request);
  }

  public getQuoteStatementForPayment(applicationId: number, paymentNumber: string): Observable<any> {
    const url = this.configService.QuoteApplicationUrl + "/credit/{id}/statement/{paymentNumber}"
      .replace("{id}", applicationId.toString())
      .replace("{paymentNumber}", paymentNumber);

    return this.apiService.find(url, null);
  }

   public getQuoteStatementForPaymentById(applicationId: number, paymentId: number): Observable<any> {
    const url = this.configService.QuoteApplicationUrl + "/{id}/payment/{paymentId}"
                                                                          .replace("{id}", applicationId.toString())
                                                                          .replace("{paymentId}", paymentId.toString());
    
    return this.apiService.find(url, null);
  }

 public getQuoteObligationStatement(applicationId: number, obligationReference: string): Observable<any> {
    const url = this.configService.QuoteApplicationUrl + "/credit/{id}/obligation/{obligationReference}"
                                                                          .replace("{id}", applicationId.toString())
                                                                          .replace("{obligationReference}", obligationReference);
    
    return this.apiService.find(url, null);
  }

  public updateApplicantContact(request: any, id: number): Observable<any> {
    const url = this.configService.updateContactUrl.replace('{id}', id.toString());
    return this.apiService.update(url, request);
  }

  public getUserAccessList(quoteId: number): Observable<any> {
    const url = this.configService.QuoteApplicationUrl + "/{quoteId}/permissions".replace("{quoteId}", quoteId.toString());
    return this.apiService.find(url, null);
  }

  public updateApplicantDetails(request: any, id: number): Observable<any> {
    const url = this.configService.updateApplicantDetailUrl.replace('{id}', id.toString());
    return this.apiService.update(url, request);
  }

  public getAcceptedObligations(quoteId:number): Observable<any> {
    const url = this.configService.quoteObligationUrl.replace("{id}",quoteId.toString());
    return this.apiService.find(url, null);
  }

  public getStatementForPayment(quoteId:number,paymentId:number): Observable<any> {
    const url = this.configService.QuoteApplicationUrl +"/{quoteId}/payment/{paymentId}"
                .replace("{quoteId}",quoteId.toString())
                .replace("{paymentId}",paymentId.toString());
    return this.apiService.find(url, null);
  }

  public IsShapeFileReady(paymentNumber: string): Observable<boolean> {
    const url = this.configService.QuoteApplicationUrl + "/shapefile/status/{paymentNumber}".replace('{paymentNumber}', paymentNumber.toString());
    return this.apiService.find<boolean>(url);
  }

  public getQuoteRegisterSettings(): Observable<SettingDto[]> {
  const apiEndpoint = this.configService.gatewayBaseUrl + '/api/settings';
  return this.apiService.findSetting<SettingResponse>(apiEndpoint).pipe(
    map(response => (response.settings || []).filter(
      s => s.parentCode === 'QTEREGSETT'
    ))
  );
 
}

public getApplicant(id: number): Observable<any> {
  const apiEndpoint = this.configService.gatewayBaseUrl + '/api/applicant/{id}'
                          .replace('{id}', id.toString());
  return this.apiService.find<any>(apiEndpoint);
}


}
